import { Component, Input, Output, EventEmitter} from '@angular/core'
import {PageChangeDto} from "../../../models/page-change-dto";

@Component({
  selector: 'app-st-pagination2',
  templateUrl: './st-pagination2.component.html',
  styleUrls: ['./st-pagination2.component.scss'],
  standalone: false
})
export class StPagination2Component {

  @Input()
  idVal: string = 'paginationId';

  lowerBoundaryId: string = this.idVal + '-lower-boundary-id';

  lowerBoundary: string = ' << ';

  previousPageId: string = this.idVal + '-previous-page-id';

  previousPage: string = ' < ';

  nextPage: string = ' > ';

  nextPageId: string = this.idVal + '-next-page-id';

  upperBoundary: string = ' >> ';

  upperBoundaryId: string = this.idVal + '-upper-boundary-id';

  pageButtonId: string = 'page-button-id';

  upperBoundaryNumber: number = 0;

  lowerBoundaryDisabled: boolean = false;
  previousPageDisabled: boolean = false;
  nextPageDisabled: boolean = false;
  upperBoundaryDisabled: boolean = false;

  @Input()
  currentPage: number = 1;

  @Input()
  collectionSize: number = 0;

  pages: any[] = [];

  pagesDisplayed: any[] = [];

  @Input()
  pageSize: number = 5;

  @Input()
  maxPagesDisplayed: number = 7;

  partialResults: number = 0;

  @Input()
  customPageSizes = [
    {
      "pageSizeId" : 50,
      "pageSize": 50
    }, {
      "pageSizeId" : 100,
      "pageSize": 100
    }, {
      "pageSizeId" : 250,
      "pageSize": 250
    }, {
      "pageSizeId" : 500,
      "pageSize": 500
    }, {
      "pageSizeId" : 1000,
      "pageSize": 1000
    }
  ];

  @Output()
  pageChange: EventEmitter<PageChangeDto> = new EventEmitter<PageChangeDto>();

  protected readonly String = String;

  initPages(collectionSize: number, pageSize: number): void {
    this.collectionSize = collectionSize;
    this.pageSize = pageSize;
    let numberOfPages: number =  Math.trunc(this.collectionSize / this.pageSize) + 1;

    this.upperBoundaryNumber = numberOfPages + 1
    this.currentPage = 1;
    this.pages = [];

    let i: number = 1;
    while(i < this.upperBoundaryNumber) {
      if (i == 1) {
        this.pages.push({
          "pageButtonId": this.idVal + '-' + this.pageButtonId + '-' + i,
          "index": i,
          "classes": ['st-button-primary']
        })
      } else {
        this.pages.push({
          "pageButtonId": this.idVal + '-' + this.pageButtonId + '-' + i,
          "index": i,
          "classes": ['st-button-secondary']
        })
      }
      i = i + 1;
    }
    this.partialResults = this.currentPage * this.pageSize;
    if (this.partialResults > this.collectionSize) {
      this.partialResults = this.collectionSize;
    }
    let actualMaxPage: number =  this.pages[this.pages.length - 1]["index"] + 1;
    this.pagesDisplayed = [];
    i = 1;
    while (i < actualMaxPage && i < this.maxPagesDisplayed) {
      if (i == 1) {
        this.pagesDisplayed.push({
          "pageButtonId": this.idVal + '-' + this.pageButtonId + '-' + i,
          "index": i,
          "classes": ['st-button-primary']
        })
      } else {
        this.pagesDisplayed.push({
          "pageButtonId": this.idVal + '-' + this.pageButtonId + '-' + i,
          "index": i,
          "classes": ['st-button-secondary']
        })
      }
      i = i + 1
    }
    this.lowerBoundaryDisabled = true;
    this.previousPageDisabled = true
    if (this.pages.length == 0 || this.pages[this.pages.length - 1]["index"] == this.currentPage) {
      this.nextPageDisabled = true;
      this.upperBoundaryDisabled = true;
    }
  }

  recalculatePages(collectionSize: number, pageSize: number, page: number): void {
    this.collectionSize = collectionSize;
    this.pageSize = pageSize;
    let numberOfPages: number =  Math.trunc(this.collectionSize / this.pageSize) + 1;

    this.upperBoundaryNumber = numberOfPages + 1

    const overflowCheck: number = page * pageSize;
    if (overflowCheck >= collectionSize) {
      this.currentPage = 1;//Redirect to first page
    } else {
      this.currentPage = page;
    }
    this.pages = [];

    let i: number = 1;
    while(i < this.upperBoundaryNumber) {
      if (i == 1) {
        this.pages.push({
          "pageButtonId": this.idVal + '-' + this.pageButtonId + '-' + i,
          "index": i,
          "classes": ['st-button-primary']
        })
      } else {
        this.pages.push({
          "pageButtonId": this.idVal + '-' + this.pageButtonId + '-' + i,
          "index": i,
          "classes": ['st-button-secondary']
        })
      }
      i = i + 1;
    }
    this.partialResults = this.currentPage * this.pageSize;
    if (this.partialResults > this.collectionSize) {
      this.partialResults = this.collectionSize;
    }
    let actualMaxPage: number =  this.pages[this.pages.length - 1]["index"] + 1;
    this.pagesDisplayed = [];
    i = 1;
    while (i < actualMaxPage && i < this.maxPagesDisplayed) {
      if (i == 1) {
        this.pagesDisplayed.push({
          "pageButtonId": this.idVal + '-' + this.pageButtonId + '-' + i,
          "index": i,
          "classes": ['st-button-primary']
        })
      } else {
        this.pagesDisplayed.push({
          "pageButtonId": this.idVal + '-' + this.pageButtonId + '-' + i,
          "index": i,
          "classes": ['st-button-secondary']
        })
      }
      i = i + 1
    }
    this.lowerBoundaryDisabled = true;
    this.previousPageDisabled = true
    if (this.pages.length == 0 || this.pages[this.pages.length - 1]["index"] == this.currentPage) {
      this.nextPageDisabled = true;
      this.upperBoundaryDisabled = true;
    }
    const pageChangeDto: PageChangeDto = {
      "page": this.currentPage,
      "pageSize": this.pageSize
    }
    this.pageChange.emit(pageChangeDto);
  }
//PageChangeDto
  updatePage(index: any): void {
    this.lowerBoundaryDisabled = false;
    this.previousPageDisabled = false;
    this.nextPageDisabled = false;
    this.upperBoundaryDisabled = false;

    const pageSizeSel = document.getElementById(this.idVal + '-page-size-dropdown-list-id');
    // @ts-ignore
    const newPageSize = pageSizeSel.value;
    if (newPageSize && newPageSize != this.pageSize) {
      this.pageSize = newPageSize;
      this.recalculatePages(this.collectionSize, this.pageSize, index);
      return;
    } else {
      // @ts-ignore
      pageSizeSel.value = this.pageSize;
    }

    this.currentPage = index;
    let i: number = 0;
    //Reset all the pages which are in ascending order
    while (i < this.pages.length) {
      this.pages[i]["classes"] = ['st-button-secondary'];
      i = i + 1;
    }
    //Set up the DisplayPages so that the current page is highlighted as primary
    i = 0;
    while (i < this.pages.length) {
      if (this.pages[i]["index"] == this.currentPage) {
        this.pages[i]["classes"] = ['st-button-primary'];
        break;
      }
      i = i + 1;
    }

    //calculate new range of DisplayedPages
    let lowDiff: number = 0;
    let lowOffsetAddToHigh: number = 0;
    let highDiff: number = 0;
    let highOffsetAddToLow: number = 0;
    let modLowBoundary: number = 0;
    let modHighBoundary: number = 0;

    modLowBoundary = this.currentPage - 3;
    modHighBoundary = this.currentPage + 3;
    if (modLowBoundary <= 1) {
      modLowBoundary = 1;
    }
    if (modHighBoundary >= this.pages.length) {
      modHighBoundary = this.pages[this.pages.length - 1]["index"];
    }

    let j: number = 0;
    this.pagesDisplayed = []
    while (j < this.pages.length) {
      if (modLowBoundary <= this.pages[j]["index"] && this.pages[j]["index"] <= modHighBoundary) {
        this.pagesDisplayed.push(this.pages[j]);
      }
      j = j + 1;
    }

    this.partialResults = this.currentPage * this.pageSize;
    if (this.partialResults > this.collectionSize || this.partialResults < this.pageSize) {
      this.partialResults = this.collectionSize;
    }
    if (this.pages.length == 0 || this.pages[0]["index"] == this.currentPage) {
      this.lowerBoundaryDisabled = true;
      this.previousPageDisabled = true;
    }
    if (this.pages.length == 0 || this.pages[this.pages.length - 1]["index"] == this.currentPage) {
      this.nextPageDisabled = true;
      this.upperBoundaryDisabled = true;
    }
    const pageChangeDto: PageChangeDto = {
      "page": this.currentPage,
      "pageSize": this.pageSize
    }
    this.pageChange.emit(pageChangeDto);
  }

  navigateToFirstPage(): void {
    if (this.currentPage == 1) {
      return
    }
    this.updatePage(1)
  }

  navigateToPreviousPage(): void {
    if (this.currentPage == 1) {
      return
    }
    this.updatePage(this.currentPage - 1)
  }


  navigateToNextPage(): void {
    if (this.currentPage == this.pages[this.pages.length - 1]["index"]) {
      return
    }
    this.updatePage(this.currentPage + 1)
  }

  navigateToLastPage(): void {
    if (this.currentPage == this.pages[this.pages.length - 1]["index"]) {
      return
    }
    this.updatePage(this.pages[this.pages.length - 1]["index"])
  }

  applyNewPageSize(): void {
    //Same page but different number of records
    this.updatePage(this.currentPage)
  }

  constructor() {
  }
}
